import React from 'react';
import { useSelector } from 'react-redux';
import { Flex } from '@qga/roo-ui/components';
import { format } from 'lib/date';
import { getQueryCheckIn, getQueryCheckOut, getQueryAdults, getQueryChildren, getQueryInfants } from 'store/router/routerSelectors';

const DATE_FORMAT = 'd MMM';

const SearchSummary = React.memo(() => {
  const checkIn = useSelector(getQueryCheckIn);
  const checkOut = useSelector(getQueryCheckOut);
  const adults = useSelector(getQueryAdults);
  const children = useSelector(getQueryChildren);
  const infants = useSelector(getQueryInfants);

  const formattedCheckIn = checkIn ? format(checkIn, DATE_FORMAT) : '';
  const formattedCheckOut = checkOut ? format(checkOut, DATE_FORMAT) : '';

  const totalGuests = (adults || 0) + (children || 0) + (infants || 0);

  return (
    <Flex alignItems="center" display={['flex', 'flex', 'none']} ml="-60px">
      {formattedCheckIn} - {formattedCheckOut} • {totalGuests} guests
    </Flex>
  );
});

SearchSummary.displayName = 'SearchSummary';

export default SearchSummary;
